import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from 'src/app/services/auth/auth.service';
import { InfoService } from 'src/app/services/info/info.service';
import { LoginService } from 'src/app/services/login/login.service';
import { environment } from 'src/environments/environment';
import { SideMenuContainerFragment } from '../side-menu-container/side-menu-container.fragment';
import { DroitsService } from 'src/app/services/droits/droits.service';
import { FeatureService } from 'src/app/services/feature/feature.service';
import { StellairService } from 'src/app/services/stellair/stellair.service';

@Component({
  selector: 'frg-side-menu',
  templateUrl: './side-menu.fragment.html',
  styleUrls: ['./side-menu.fragment.scss']
})
export class SideMenuFragment implements OnInit {

  public open = false;
  public imgs = new Array();
  public page = 'home';
  public fullVersion = '';

  public canAccessPatients = true;
  public canAccessMessagerie = true;
  public canAccessAgenda = true;
  public canAccessComptabilite = true;
  public canAccessUtilitaires = true;
  public canAccessSettings = true;

  public canAccessDonneesMedicales = true;

  constructor(
    private _container: SideMenuContainerFragment,
    private _router: Router,
    private _auth: AuthService,
    private _login: LoginService,
    private _infoService: InfoService,
    private _oauthService: OAuthService,
    private _droitService: DroitsService,
    private _featureSrv: FeatureService,
    private _stellairSrv: StellairService,
  ) {
    if (!this._container) {
      throw new Error(
        '<frg-side-menu> must be inside a <frg-side-menu-container>. '
      );
    }
    this._router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if ((val as NavigationEnd).url && (val as NavigationEnd).url !== '') {
          const urlPath = (val as NavigationEnd).url.split('/');
          // urlPath = ['', 'user', 'NomDeLaZone'];
          if (urlPath[2]) {
            this.page = urlPath[2];
          } else {
            this.page = 'home';
          }
        }
      }
    });
  }

  public async initPSC(): Promise<void> {
    const authCodeFlowConfig: AuthConfig = {
      issuer: environment.pscIssuer,
      redirectUri: environment.sitePath + '/login?type=psc',
      postLogoutRedirectUri: environment.sitePath + '/login',
      // Pas dans une popup car mal géré par la librairie
      // (tente de faire absolument un login alors qu'il doit être fait coté serveur)
      // silentRefreshRedirectUri: environment.sitePath + '/silent-refresh.html',
      clientId: environment.pscClientId,
      responseType: 'code',
      scope: 'openid scope_all',
      // oidc: false,
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
      customQueryParams: {
        acr_values: environment.pscOIDACR
      }
    };
    this._oauthService.configure(authCodeFlowConfig);
    await this._oauthService.loadDiscoveryDocument(environment.pscDiscorveryDocument);
  }

  public routeTo(event: any): void {
    const getHrefValue = (elem: HTMLElement): string => {
      if (!elem) {
        return '/home';
      } else if ((elem.tagName === 'a' || elem.tagName === 'A')) {
        return elem.getAttribute('href');
      } else {
        return getHrefValue(elem.parentElement);
      }
    };

    const href = getHrefValue(event.target.parentElement);
    event.preventDefault();
    this._router.navigateByUrl(href);
  }

  public getVersion(): string {
    return environment.version + (environment.env !== "prod" ? "-" + environment.env : "");
    // return '0.3.9-staging';
  }

  public async getFullVersion(): Promise<string> {
    const informations = await this._infoService.getBackendInfos();
    return "Version:\nClient: " + environment.version + "-" + environment.buildTimestamp + (environment.env !== "prod" ? "-" + environment.env : "") + "\n" +
      "API: " + informations.backVersion + "\n" +
      "DB Hypermed: " + informations.hypermedDBVersion + "\n" +
      "DB User: " + informations.userDBVersion + "\n" +
      "DB Medical: " + informations.medicalDBVersion;
  }

  public async ngOnInit(): Promise<void> {
    this._container.addSidebar(this);
    this.pload('/assets/icons-white/home.svg',
      '/assets/icons-white/home.svg',
      '/assets/icons-white/users.svg',
      '/assets/icons-white/mail.svg',
      '/assets/icons-white/calendar.svg',
      '/assets/icons-white/calculator.svg',
      '/assets/icons-white/compta.svg',
      '/assets/icons-white/options.svg',
      '/assets/icons-white/call-phone.svg',
      '/assets/icons-white/notification.svg',
      '/assets/icons-white/settings.svg');
    this.fullVersion = await this.getFullVersion();
    const authTechInfo = this._login.getAuthTechInfo();
    if (authTechInfo && authTechInfo.authType === 'psc') {
      await this.initPSC();
    }

    await this.getDroitsAccessAndUpdateMenu();
  }

  public pload(...args: any[]): void {
    for (let i = 0; i < args.length; i++) {
      this.imgs[i] = new Image();
      this.imgs[i].src = args[i];
    }
  }

  public async logout(): Promise<void> {
    if (this._login.logoutInProgress) {
      return;
    }
    this._login.logoutInProgress = true;

    const authInfo = this._login.getAuthTechInfo();
    if (authInfo) {
      await this._auth.logout(authInfo.authType, authInfo.authId);
    }
    await this._auth.logoutSession();
    this._login.clearLocalSession();
    this._featureSrv.clearCache();
    this._stellairSrv.logout();
    this._router.navigateByUrl('/');
  }

  public contact(): void {
    this._router.navigateByUrl('/contact');
  }

  public async getDroitsAccessAndUpdateMenu(): Promise<void> {
    const combinatedRights = await this._droitService.findMyCombinedDroits();
    this.canAccessDonneesMedicales = combinatedRights.donneesMedicales;
  }
}
